import { Box, Link, Paper, Typography } from '@mui/material'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { TypedEvent, XyoWorldMinterEvents } from '@xyo-network/world-typechain'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import EthBlock from '../../EthBlock'
import AuctionStartedEventComponent from './AuctionStartedEvent'
import BidPlacedEventComponent from './BidPlacedEvent'
import GeotokenMintedEventCard from './GeotokenMintedEventCard'
import MintingFeeSentEventCard from './MintingFeeSentEventCard'
import RefundedCurrentBidEventCard from './RefundedCurrentBidEventCard'
import TokensBurnedEventCard from './TokensBurnedEventCard'
import TokensFlowedEventCard from './TokensFlowedEvent'

export interface EventProps {
  event: TypedEvent
  id?: Quadkey
}

const EventBody: React.FC<EventProps> = (props) => {
  const { event } = props
  switch (event.event) {
    case 'BidPlaced':
      return <BidPlacedEventComponent event={event as XyoWorldMinterEvents.BidPlaced} />
    case 'RefundedCurrentBid':
      return <RefundedCurrentBidEventCard event={event as XyoWorldMinterEvents.RefundedCurrentBid} />
    case 'AuctionStarted':
      return <AuctionStartedEventComponent event={event as XyoWorldMinterEvents.AuctionStarted} />
    case 'TokensFlowed':
      return <TokensFlowedEventCard event={event as XyoWorldMinterEvents.TokensFlowed} />
    case 'MintingFeeSent':
      return <MintingFeeSentEventCard event={event as XyoWorldMinterEvents.MintingFeeSent} />
    case 'TokensBurned':
      return <TokensBurnedEventCard event={event as XyoWorldMinterEvents.TokensBurned} />
    case 'GeotokenMinted':
      return <GeotokenMintedEventCard event={event as XyoWorldMinterEvents.GeotokenMinted} />
    default:
      return null
  }
}

const EventBox: React.FC<EventProps> = (props) => {
  const { event } = props
  const { blockNumber, args } = event
  const { version } = args
  return (
    <Box component={Paper} display="flex" flexGrow={1} margin={0.5} padding={0.5}>
      <Box alignItems="center" display="flex" marginX={0.5}>
        <EventBody {...props} />
      </Box>
      <Box flexGrow={1} />
      <Box alignItems="center" display="flex">
        <EthBlock block={blockNumber} />
      </Box>
      <Box alignItems="center" display="flex" marginX={0.5}>
        <Link component={RouterLink} title="XYO World version for this event" to="/contracts">
          <Typography color="textSecondary" style={{ opacity: 0.5 }} variant="caption">
            {version}
          </Typography>
        </Link>
      </Box>
    </Box>
  )
}

export default EventBox
